export const PRODUCT_TYPES = ['power', 'gas'] as const;
